// extracted by mini-css-extract-plugin
export default {"commentContent__samples":"styles_comment-content__samples__FW2be","commentContent__message":"styles_comment-content__message__kRsE8"};